
let router: any = null;

export const setRouter = (r: any) => {
    router = r;
};

export const getRouter = () => {
    return router;
};
